/** Canonical legal pages on the main QikTruck website (customer-fe). */
export const QIKTRUCK_TERMS_URL = "https://qiktruck.co.za/terms";
export const QIKTRUCK_PRIVACY_URL = "https://qiktruck.co.za/privacy";
/** Partner API and business portal section on the main terms page. */
export const QIKTRUCK_PARTNER_API_TERMS_URL =
  "https://qiktruck.co.za/terms#business-portal-partner-api";
